import React from 'react'
import LoadingV3 from '../../components/Loading/LoadingV3'
import { Col, Row } from 'reactstrap'
import { numberWithCommas } from '../../../utils/function'

function InfoBox(props) {
    return (
        <>
            {props.twoInrow ? (
                <div className='whiteContainer'>
                    <Row className="justify-content-center align-items-center mx-0 px-0">
                        <Col lg={6} md={6} sm={12} xs={12} className="border-right-box">
                            <div className='d-flex align-items-center h-100 w-100 py-3 px-0 mx-0'>
                                <div className='w-100'>
                                    <div>
                                        {props.icon ? (
                                            <img src={props.icon} className="img-fluid" alt="personal-sales" />
                                        ) : null}
                                        <span className="font-weight-500 font-20 line-height-26 white-container-title">{props.boxLabel}</span>
                                    </div>
                                    {props.loading ? (<LoadingV3 theme="light" />) : (
                                        <div className="textFieldBg w-100 align-items-center px-2 py-2 mt-3">
                                            <span className="font-weight-500 font-24 text-black">{props.boxValue}</span>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </Col>
                        <Col lg={6} md={6} sm={12} xs={12} className="py-0">
                            <div className='d-flex align-items-center h-100 w-100 py-3 px-0 mx-0'>
                                <div className='w-100'>
                                    <div>
                                        {props.icon2 ? (
                                            <img src={props.icon2} className="img-fluid" alt="group-sales" />
                                        ) : null}
                                        <span className="font-weight-600 font-18 line-height-26 white-container-title">{props.boxLabel2}</span>
                                    </div>
                                    {props.loading ? (<LoadingV3 theme="light" />) : (
                                        <div className="textFieldBg w-100 align-items-center px-2 py-2 mt-3">
                                            <span className="font-weight-500 font-24 text-black">{props.boxValue2}</span>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            ) : (
                <div className="whiteContainer py-3">
                    <div className='p-xl-3 p-md-2 p-2'>
                        <div>
                            {props.icon ? (
                                <img src={props.icon} className="img-fluid" alt="icon-wallet" />
                            ) : null}
                            <span className="font-weight-500 font-20 line-height-26 white-container-title">{props.boxLabel}</span>
                        </div>
                        {props.loading ? (
                            <LoadingV3 theme="light" />
                        ) : (
                            <div className='textFieldBg w-100 mt-3'>
                                <div className="w-100 align-items-center px-3 py-2 mt-3">
                                    <span className="font-weight-500 font-24 text-black">{props.boxValue}</span>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </>
    )
}

export default InfoBox